<div class="portal--header portal--header__progress">
    <h1 class="heading">Multi-device management: <span style="text-transform:capitalize; color: #fff">{{activeState}}</span></h1>
    <ul class="c-progress-bar">
        <li class="c-progress-bar--item" *ngFor="let item of items" [ngClass]="{'active':activeState === item.type && activeState !== 'summary'}">
            <ng-container *ngIf="item.isShown">
                <a class="focus-content c-progress-bar--item--edit" (click)="onClick(item)">
                    <span class="focus--content">
                        <svg *ngIf="!item.isComplete" class="c-progress-bar--item--ic"><use xlink:href="#ic-question-white" href="#ic-question-white"></use></svg>
                        <svg *ngIf="item.isComplete" class="c-progress-bar--item--ic"><use xlink:href="#ic-check-light" href="#ic-check-light"></use></svg>
                        <div class="c-progress-bar--item--heading-wrapper">
                            <svg class="c-progress-bar--item--heading--ic">
                                <use xlink:href="#ic-edit-white" href="#ic-edit-white"></use>
                            </svg>
                            <span class="c-progress-bar--item--heading">{{item.type}}</span>
                        </div>
                    </span>
                </a>
            </ng-container>
        </li>
    </ul>
</div>
